import React from 'react'
import moment from 'moment-mini'
import './printSample.less'

interface Props {
  currentFont: string
  fontIncreaser: number
}

const fullDateFormat = (date: number) => moment(date).format('DD.MM.YYYY HH:mm')

const PrintSample: React.FC<Props> = ({ currentFont, fontIncreaser }: Props) => {
  const totalWeight = 16830
  const note1 = 'test note 1'
  const note2 = 'test note 2'
  const note3 = ''
  return (
    <div className="vehicleCard" style={{ fontFamily: currentFont, fontSize: 15 + fontIncreaser }}>
      <div className="container">
        <div className="block">
          <div className="ship bold">MEGASTAR</div>
          <div className="card-name">Vehicle Boarding Card</div>
          <div className="row">
            <div>TALLIN-HELSINKI</div>
            &nbsp;&nbsp;
            <div>{fullDateFormat(1578552900339)}</div>
          </div>
        </div>
        <div className="left-side vertical-text">Vehicle</div>
        <div className="right-side vertical-text">2 DRIVERS</div>
        <div className="block">
          <div>{note1}</div>
          <div>{note2}</div>
          <div>{note3}</div>
        </div>
        <div className="block">
          <div className="row">
            <div>ALDAL123</div>
            <div>&nbsp;+&nbsp;</div>
            <div>KLSK23234</div>
          </div>
          <div>TRACK-TRAILER</div>
          <div className="row">
            <div>Weight:&nbsp;{totalWeight}&nbsp;kg</div>
            <div>,&nbsp;Length:&nbsp;18&nbsp;m</div>
          </div>
        </div>
        <div className="block">
          <div>RES&nbsp;ID:&nbsp;12123112312</div>
        </div>
      </div>
      <div className="page-break" />
    </div>
  )
}

export default PrintSample
